<template>
  <div class="cx-app">
    <div class="cx-showcase cxu-d-flex-c" id="app">
      <div class="cx-showcase__list cxu-flex-1 cxu-p-10">
        <ul>
          <li v-for="(componentLink, index) in componentLinks" :key="index">
            <a :href="componentLink.href">{{ componentLink.name }}</a>
          </li>
        </ul>
      </div>
      <div class="cx-showcase__content cxu-d-flex-r cxu-flex cxu-ml-20 cxu-p-30">
        <CxTextAreaShowcase/>
        <CxButtonShowcase/>
        <CxListShowcase/>
        <CxSelectShowcase/>
        <CxIconShowcase/>
        <CxToggleShowcase/>
        <CxCheckboxShowcase/>
        <CxToggleSwitchShowcase/>
        <CxTabControlShowcase/>
        <CxComboboxShowcase/>
        <CxInputShowcase/>
        <DateRangePickerShowcase/>
        <CxDateTimePickerShowcase/>
      </div>
    </div>
  </div>
</template>

<script>
import CxButtonShowcase from './components/CxButtonShowcase';
import CxListShowcase from './components/CxListShowcase';
import CxSelectShowcase from '@/components/showcase/CxSelectShowcase';
import CxIconShowcase from './components/CxIconShowcase';
import CxToggleShowcase from './components/CxToggleShowcase';
import CxCheckboxShowcase from './components/CxCheckboxShowcase';
import CxToggleSwitchShowcase from './components/CxToggleSwitchShowcase';
import CxTextAreaShowcase from '@/components/showcase/components/CxTextAreaShowcase';
import CxTabControlShowcase from '@/components/showcase/components/CxTabControlShowcase';
import CxComboboxShowcase from '@/components/showcase/components/CxComboboxShowcase';
import CxInputShowcase from '@/components/showcase/components/CxInputShowcase';
import DateRangePickerShowcase from '@/components/showcase/components/CxDateRangePickerShowcase';
import CxDateTimePickerShowcase from '@/components/showcase/components/CxDateTimePickerShowcase';

export default {
  name: 'CxShowcase',
  components: {
    CxTextAreaShowcase,
    CxButtonShowcase,
    CxListShowcase,
    CxSelectShowcase,
    CxIconShowcase,
    CxToggleShowcase,
    CxCheckboxShowcase,
    CxToggleSwitchShowcase,
    CxTabControlShowcase,
    CxComboboxShowcase,
    CxInputShowcase,
    DateRangePickerShowcase,
    CxDateTimePickerShowcase
  },
  computed: {
    componentLinks() {
      const components = [];
      Object.keys(this.$options.components).forEach((key) => {
        components.push(this.$options.components[key]);
      });
      return components.map(c => {
        return {
          href: `#${c.data().name}`,
          name: c.data().name
        };
      });
    },
  }
};
</script>

<style lang="less">
@import '../../common';

.cx-showcase {
  background-color: @appBodyBackgroundColor;
  height: 100vh;
  font-family: @appFontFamily;
  font-weight: @appFontWeight;
  font-size: @appFontSize;
  color: @textColor;
  margin: 0;
  padding: 0;

  &#app {
    color: @textColor;
  }

  .cx-showcase-section {
    margin-top: 30px;
  }

  .cx-showcase__content {
    overflow: auto;
  }


  .cx-showcase__content {
    background-color: @baseBackgroundColor;
    border-radius: 4px;
  }

  .cx-showcase__list {
    background-color: @baseBackgroundColor;
    ul {
      padding-left: 24px;
    }
  }

  a {
    color: #2196f3;
    text-decoration: none;

    &:hover {
      color: @textColorHighlight;
    }
  }

  ul {
    list-style-type: none;

    li {
      font-size: 14px;
      padding: 8px 10px;
      margin-top: 8px;
    }
  }

}

.cx-showcase#app {
  padding: 20px;
}
</style>